import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/privateAccountDocumentService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

class PrivateAccountDocumentForm extends Form {
  state = {
    imageUrl: false,
    renewalDate: new Date(),
    expiryDate: new Date(),
    attachment_type_options: [
      { id: "", name: "Select option" },
      { id: "simple", name: "Simple" },
      { id: "complex", name: "Complex" },
    ],
    data: {
      name: "",
      attachment_type_option: "",
    },
    errors: {},
  };

  schema = {
    id: Joi.string(),
    name: Joi.string().required().label("Name"),
    attachment_type_option: Joi.string().required().label("Attachment Type"),
    // renewalDate: Joi.string().label("Renewal Date"),
    // expiryDate: Joi.string().label("Expiry Date")
  };

  componentDidMount() {
    const visaId = this.props.match.params.id;
    localStorage.setItem("visaId", visaId);
  }

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      let formData = new FormData();
      formData.append("name", this.state.data.name);
      formData.append("type", this.state.data.attachment_type_option);
      formData.append("attachment", this.state.imageUrl);

      var event = new Date(this.state.renewalDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("renewal_date", date);

      event = new Date(this.state.expiryDate);
      date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("expiry_date", date);

      await saveSingle(formData);
      toast.success("Document has been added successfully.");
      this.setState({ blocking: false });
      const visaId = localStorage.getItem("visaId");
      this.props.history.push("/private-accounts/view/" + visaId);
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.attachment_type_options)
          errors.attachment_type_options =
            ex.response.data.errors.attachment_type_options;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  handleChangeRenewal = (date) => {
    this.setState({
      renewalDate: date,
    });
  };

  handleChangeExpiry = (date) => {
    this.setState({
      expiryDate: date,
    });
  };

  createImage = (file) => {
    let reader = new FileReader();
    // reader.onload = e => {
    //   this.setState({ imagePreviewUrl: e.target.result });
    // };
    reader.readAsDataURL(file);
  };

  onChangeFile = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add Account Document</h1>

        <Link
          to={`/private-accounts/view/${this.props.match.params.id}`}
          className="btn btn--secondary"
        >
          Back
        </Link>
        <br />
        <br />
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add account document</h3>
              <p>Provide the information below to add the document.</p>
              {this.renderInput("name", "Document Name", "text")}
              {this.renderSelect(
                "attachment_type_option",
                "Attachment Type",
                this.state.attachment_type_options
              )}
              <div>
                <label>Attachment</label>
                <input
                  className="input"
                  type="file"
                  onChange={this.onChangeFile}
                />
              </div>
              <div>
                <label>Renewal Date</label>
                <br />
                <DatePicker
                  className="input"
                  selected={this.state.renewalDate}
                  onChange={this.handleChangeRenewal}
                />
              </div>
              <div>
                <label>Expiry Date</label>
                <br />
                <DatePicker
                  className="input"
                  selected={this.state.expiryDate}
                  onChange={this.handleChangeExpiry}
                />
              </div>
              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default PrivateAccountDocumentForm;
